import React from 'react';
import { BlockStack, Box, Divider, InlineGrid, SkeletonBodyText, SkeletonDisplayText, useBreakpoints } from '@shopify/polaris';


export const PricingGridSkelton = () => {
  const breakpoints = useBreakpoints();
  const cardLength = (breakpoints?.smDown && 1) || (breakpoints?.lgDown && 2) || 3;
  return (
    <InlineGrid columns={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }} gap={"400"}>
      {Array.from({ length: cardLength }, (_, index) => {
        return (
          <div className='Custom-NewPricing--Card' key={index}>
            <Box background='bg-surface-selected' padding={"500"} borderRadius='300'>
              <BlockStack gap={"500"}>
                <BlockStack gap={"300"}>
                  <BlockStack gap={"800"}>
                    <BlockStack gap={"200"}>
                      <div className='custom-new-prcing-btn__skelton'><SkeletonDisplayText /></div>
                      <SkeletonBodyText lines={2} />
                    </BlockStack>
                    <SkeletonDisplayText />
                  </BlockStack>
                  <SkeletonDisplayText />
                  <Divider borderColor='border' />
                  <div className='custom-feature-skelton'>
                    <BlockStack inlineAlign='start' gap={"200"}>
                      {Array.from({ length: 8 }, (_, ind) => (
                        <SkeletonBodyText key={ind} lines={1} />
                      ))}
                    </BlockStack>
                  </div>
                </BlockStack>
                <div className='custom-new-prcing-btn__skelton'><SkeletonDisplayText size='medium' /></div>
              </BlockStack>
            </Box>
          </div>
        )
      })}
    </InlineGrid>
  )
}

export const MarketingGridSkelton = () => {
  return (
    <>{
      Array.from({ length: 3 }, (_, index) => {
        return (
          <div className='Custom-radius-12 custom-support-offer__card' key={index}>
            <Box background={'bg-surface-selected'} padding={"500"} borderRadius='300'>
              <BlockStack gap={"500"} align='space-between'>
                <BlockStack gap={"400"}>
                  <div className='custom-feature-skelton'> <SkeletonBodyText lines={1} /></div>
                  <Divider borderColor={'border-brand'} />
                  <div className='custom-feature-skelton'>
                    <BlockStack inlineAlign='start' gap={"200"}>
                      {Array.from({ length: 8 }, (_, ind) => (
                        <SkeletonBodyText lines={1} key={ind} />
                      ))}
                    </BlockStack>
                  </div>
                </BlockStack>
                <div className='custom-new-prcing-btn__skelton'><SkeletonDisplayText size='medium' /></div>
              </BlockStack>
            </Box>
          </div>
        )
      })}
    </>
  )
}